module.exports = __webpack_public_path__ + "img/gate-rail-vertical-shadow-right.2e35c808.png";